// @flow
import * as React from 'react';
import { openTab } from '../../../src/utils/openTab';

type LinkProps = {
  children: Array<React.Node | string>,
  linkTo: string,
  nofollow: bool,
};

export const ExternalLink = ({
  children,
  linkTo,
  nofollow,
}: LinkProps): React.Node => (
  <a href={linkTo} onClick={e => openTab(linkTo, e)} rel={nofollow ? 'nofollow' : null} >
    {children}
  </a>
);



// WEBPACK FOOTER //
// ./shared/components/ExternalLink/ExternalLink.js